<template>
  <div v-perms="['analytics']" class="kt-header__topbar-item analytics-link-holder">
    <a :href="radar_base_url" target="_blank" class="btn btn-ss">
      <i class="flaticon2-analytics-2" />
      <span>Analytics</span><span class="ml-2 badge badge-success ">new</span>
    </a>
  </div>
</template>

<script>

import RadarMixin from "VueMixins/Analytics/RadarMixin";

export default {
  mixins: [RadarMixin],
};
</script>
<style lang="scss" scoped>
.analytics-link-holder {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-item-align: center;
  align-self: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 44px;
  cursor: pointer;
  margin-right:1em;
}
</style>
